// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavBar_container__tDXCs {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ---------------------------navbar------------------------------ */

.NavBar_container__tDXCs .NavBar_navbar__cYhDd {
  animation: NavBar_init2__gySGV 1s;
  width: 20vw;
  left: -15%;
  transition: 0.5s;
  display: flex;
  position: fixed;
  height: 100vh;
  overflow-y: hidden;
  border-radius: 0 25px 25px 0;
  box-shadow: 11px 0 31px -13px rgba(0, 0, 0, 0.286);
  z-index: 40;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navContent__ngN1n {
  width: 82%;
  transition: 0.3s;
  overflow-x: hidden;
  overflow-y: auto;
  margin-right: 10px;
  padding-bottom: 50px;
  scrollbar-color: rgba(50, 83, 72, 0) rgba(93, 93, 93, 0);
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navContent__ngN1n::-webkit-scrollbar {
  width: 3px;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navContent__ngN1n::-webkit-scrollbar-thumb {
  height: 50%;
  background-color: rgba(93, 93, 93, 0.09);
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_arrowNav__IvjLB {
  display: flex;
  width: 18%;
  justify-content: center;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_arrowNav__IvjLB .NavBar_arrowIcon__0MjbZ {
  transition: 0.5s;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  margin-right: 45px;
  width: 90%;
  rotate: 180deg;
  border-radius: 100%;
  height: 70px;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_arrowNav__IvjLB .NavBar_arrowIcon__0MjbZ:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(1.3);
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.NavBar_container__tDXCs .NavBar_open__ERV6K {
  transition: 0.5s;
  left: 0;
}

.NavBar_container__tDXCs .NavBar_open__ERV6K .NavBar_arrowNav__IvjLB .NavBar_arrowIcon__0MjbZ {
  transition: 0.5s;
  rotate: 0deg;
  margin-right: 0;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_openarrow__E21js {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  width: 100%;
  height: 50px;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX .NavBar_abaco_logo__mme8y {
  margin-top: 20px;
  max-width: 10rem;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX .NavBar_profile__yy2lJ {
  display: flex;
  justify-content: center;
  align-items: center;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX .NavBar_avatar__esDwP {
  display: flex;
  flex-direction: column;
  width: 30%;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX .NavBar_avatar__esDwP .NavBar_profilepic__yut\\+L {
  border: 5px solid rgba(165, 165, 165, 0.245);
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX .NavBar_username__GsYuF {
  width: 70%;
  margin-left: 15px;
  font-size: 1rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX .NavBar_selector__lxqwS {
  width: 70%;
  height: 50px;
  margin-bottom: 1rem;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_listItem__2nzjs {
  text-decoration: none;
  width: 100%;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_itemContainer__Uy-Qf {
  margin-top: 0.8rem;
  height: 2rem;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_itemContainer__Uy-Qf .NavBar_listItem__2nzjs .NavBar_itemButton__UJzcn {
  border-radius: 5px;
  width: 100%;
}

.NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_itemContainer__Uy-Qf .NavBar_selectedItem__nj7Id {
  transition: 0.3s;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.135);
}
/* ---------------------------content------------------------------ */

.NavBar_container__tDXCs .NavBar_content__qDAh7 {
  transition: 0.5s;
  margin-left: 5vw;
  width: 90vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.NavBar_container__tDXCs .NavBar_openContent__uoudR {
  transition: 0.5s;
  margin-left: 20vw;
}

.NavBar_container__tDXCs .NavBar_content__qDAh7 .NavBar_headerPos__OmdjV {
  width: 100%;
  height: auto;
}

.NavBar_container__tDXCs .NavBar_content__qDAh7 .NavBar_headerPos__OmdjV .NavBar_mobileHeader__TlYny {
  display: none;
  width: 100%;
}

.NavBar_container__tDXCs .NavBar_content__qDAh7 .NavBar_outletPos__NGszb {
  width: 100%;
  height: 85%;
}

@keyframes NavBar_init2__gySGV {
  0% {
    opacity: 0;
    left: -40%;
  }
  100% {
    opacity: 1;
    left: -33%;
  }
}

@media screen and (max-width: 1300px) {
  .NavBar_container__tDXCs .NavBar_navbar__cYhDd {
    width: 20vw;
  }

  .NavBar_container__tDXCs .NavBar_content__qDAh7 {
    margin-left: 10vw;
    width: 90vw;
  }

  .NavBar_container__tDXCs .NavBar_openContent__uoudR {
    margin-left: 20vw;
  }
}

@media screen and (max-width: 1100px) {
  .NavBar_container__tDXCs .NavBar_navbar__cYhDd {
    width: 30vw;
  }

  .NavBar_container__tDXCs .NavBar_content__qDAh7 {
    margin-left: 10vw;
    width: 100%;
  }
}

@media screen and (max-width: 1000px) {
  .NavBar_container__tDXCs .NavBar_navbar__cYhDd {
    animation: NavBar_init2__gySGV 1s;
    width: 40vw;
    left: -33%;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navContent__ngN1n {
    width: 85%;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_arrowNav__IvjLB {
    width: 15%;
    display: flex;
    justify-content: center;
  }

  .NavBar_container__tDXCs .NavBar_open__ERV6K {
    left: 0;
  }

  .NavBar_container__tDXCs .NavBar_open__ERV6K .NavBar_arrowNav__IvjLB .NavBar_arrowIcon__0MjbZ {
    transition: 0.5s;
    rotate: 0deg;
    margin-right: 0;
  }

  .NavBar_container__tDXCs .NavBar_content__qDAh7 {
    margin-left: 10vw;
    width: 90vw;
  }
}

@media screen and (max-width: 600px) {
  .NavBar_container__tDXCs {
    flex-direction: column;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd {
    animation: none;
    width: 80vw;
    left: -80vw;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navContent__ngN1n {
    width: 100%;
  }

  .NavBar_container__tDXCs .NavBar_open__ERV6K {
    left: 0;
  }

  .NavBar_container__tDXCs .NavBar_content__qDAh7 {
    width: 100%;
    margin-left: 0;
  }

  .NavBar_container__tDXCs .NavBar_content__qDAh7 .NavBar_headerPos__OmdjV .NavBar_mobileHeader__TlYny {
    display: flex;
  }

  .NavBar_container__tDXCs .NavBar_content__qDAh7 .NavBar_headerPos__OmdjV {
    width: 100%;
  }

  .NavBar_container__tDXCs .NavBar_content__qDAh7 .NavBar_headerPos__OmdjV .NavBar_webHeader__jARTM {
    display: none;
  }
}

@media screen and (min-height: 700px) {
  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_itemContainer__Uy-Qf {
    margin-top: 5px;
    height: 50px;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX .NavBar_avatar__esDwP .NavBar_profilepic__yut\\+L {
    width: 60px;
    height: 60px;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX .NavBar_avatar__esDwP .NavBar_username__GsYuF {
    font-size: 18px;
  }
}

@media screen and (min-height: 700px) {
  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_itemContainer__Uy-Qf {
    margin-top: 5px;
    height: 40px;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX .NavBar_avatar__esDwP .NavBar_profilepic__yut\\+L {
    width: 60px;
    height: 60px;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX .NavBar_avatar__esDwP .NavBar_username__GsYuF {
    font-size: 18px;
  }
}

@media screen and (max-height: 600px) {
  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_abaco_logo__mme8y {
    display: none;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_itemContainer__Uy-Qf {
    margin-top: 10px;
    height: 25px;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX .NavBar_avatar__esDwP .NavBar_profilepic__yut\\+L {
    width: 50px;
    height: 50px;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navHeader__37uAX .NavBar_avatar__esDwP .NavBar_username__GsYuF {
    font-size: 16px;
  }
}

@media screen and (max-width: 600px) {
  .NavBar_container__tDXCs {
    position: relative;
    flex-direction: column;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_abaco_logo__mme8y {
    width: 20rem;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd {
    transition: 0.5s;
    animation: none;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: -100vw;
    border-radius: 0;
    opacity: 0.94;
  }

  .NavBar_container__tDXCs .NavBar_navbar__cYhDd .NavBar_navContent__ngN1n {
    width: 100%;
  }

  .NavBar_container__tDXCs .NavBar_open__ERV6K {
    transition: 0.5s;
    left: 0;
  }

  .NavBar_container__tDXCs .NavBar_content__qDAh7 {
    width: 100%;
    height: 100%;
    margin-left: 0;
  }

  .NavBar_container__tDXCs .NavBar_content__qDAh7 .NavBar_headerPos__OmdjV .NavBar_mobileHeader__TlYny {
    display: flex;
  }

  .NavBar_container__tDXCs .NavBar_content__qDAh7 .NavBar_headerPos__OmdjV {
    width: 100%;
  }

  .NavBar_container__tDXCs .NavBar_content__qDAh7 .NavBar_headerPos__OmdjV .NavBar_webHeader__jARTM {
    display: none;
  }

  .NavBar_container__tDXCs .NavBar_content__qDAh7 .NavBar_outletPos__NGszb {
    margin-top: 20%;
  }
}

@media print {
  .NavBar_navbar__cYhDd {
    display: none !important;
  }
  .NavBar_navHeader__37uAX {
    display: none !important;
  }
  .NavBar_username__GsYuF {
    display: none !important;
  }
  .NavBar_open__ERV6K {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation/NavBar/NavBar.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,oEAAoE;;AAEpE;EACE,iCAAmB;EACnB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;AACA,qEAAqE;;AAErE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;EACE;IACE,iCAAmB;IACnB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,OAAO;EACT;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* ---------------------------navbar------------------------------ */\n\n.container .navbar {\n  animation: init2 1s;\n  width: 20vw;\n  left: -15%;\n  transition: 0.5s;\n  display: flex;\n  position: fixed;\n  height: 100vh;\n  overflow-y: hidden;\n  border-radius: 0 25px 25px 0;\n  box-shadow: 11px 0 31px -13px rgba(0, 0, 0, 0.286);\n  z-index: 40;\n}\n\n.container .navbar .navContent {\n  width: 82%;\n  transition: 0.3s;\n  overflow-x: hidden;\n  overflow-y: auto;\n  margin-right: 10px;\n  padding-bottom: 50px;\n  scrollbar-color: rgba(50, 83, 72, 0) rgba(93, 93, 93, 0);\n}\n\n.container .navbar .navContent::-webkit-scrollbar {\n  width: 3px;\n}\n\n.container .navbar .navContent::-webkit-scrollbar-thumb {\n  height: 50%;\n  background-color: rgba(93, 93, 93, 0.09);\n}\n\n.container .navbar .arrowNav {\n  display: flex;\n  width: 18%;\n  justify-content: center;\n}\n\n.container .navbar .arrowNav .arrowIcon {\n  transition: 0.5s;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 20px;\n  margin-right: 45px;\n  width: 90%;\n  rotate: 180deg;\n  border-radius: 100%;\n  height: 70px;\n}\n\n.container .navbar .arrowNav .arrowIcon:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(1.3);\n}\n\n.container .navbar .navHeader {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .open {\n  transition: 0.5s;\n  left: 0;\n}\n\n.container .open .arrowNav .arrowIcon {\n  transition: 0.5s;\n  rotate: 0deg;\n  margin-right: 0;\n}\n\n.container .navbar .openarrow {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n  width: 100%;\n  height: 50px;\n}\n\n.container .navbar .navHeader .abaco_logo {\n  margin-top: 20px;\n  max-width: 10rem;\n}\n\n.container .navbar .navHeader .profile {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .navbar .navHeader .avatar {\n  display: flex;\n  flex-direction: column;\n  width: 30%;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 10px;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .navbar .navHeader .avatar .profilepic {\n  border: 5px solid rgba(165, 165, 165, 0.245);\n}\n\n.container .navbar .navHeader .username {\n  width: 70%;\n  margin-left: 15px;\n  font-size: 1rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .navbar .navHeader .selector {\n  width: 70%;\n  height: 50px;\n  margin-bottom: 1rem;\n}\n\n.container .navbar .listItem {\n  text-decoration: none;\n  width: 100%;\n}\n\n.container .navbar .itemContainer {\n  margin-top: 0.8rem;\n  height: 2rem;\n}\n\n.container .navbar .itemContainer .listItem .itemButton {\n  border-radius: 5px;\n  width: 100%;\n}\n\n.container .navbar .itemContainer .selectedItem {\n  transition: 0.3s;\n  border-radius: 10px;\n  background-color: rgba(0, 0, 0, 0.135);\n}\n/* ---------------------------content------------------------------ */\n\n.container .content {\n  transition: 0.5s;\n  margin-left: 5vw;\n  width: 90vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .openContent {\n  transition: 0.5s;\n  margin-left: 20vw;\n}\n\n.container .content .headerPos {\n  width: 100%;\n  height: auto;\n}\n\n.container .content .headerPos .mobileHeader {\n  display: none;\n  width: 100%;\n}\n\n.container .content .outletPos {\n  width: 100%;\n  height: 85%;\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    left: -40%;\n  }\n  100% {\n    opacity: 1;\n    left: -33%;\n  }\n}\n\n@media screen and (max-width: 1300px) {\n  .container .navbar {\n    width: 20vw;\n  }\n\n  .container .content {\n    margin-left: 10vw;\n    width: 90vw;\n  }\n\n  .container .openContent {\n    margin-left: 20vw;\n  }\n}\n\n@media screen and (max-width: 1100px) {\n  .container .navbar {\n    width: 30vw;\n  }\n\n  .container .content {\n    margin-left: 10vw;\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .container .navbar {\n    animation: init2 1s;\n    width: 40vw;\n    left: -33%;\n  }\n\n  .container .navbar .navContent {\n    width: 85%;\n  }\n\n  .container .navbar .arrowNav {\n    width: 15%;\n    display: flex;\n    justify-content: center;\n  }\n\n  .container .open {\n    left: 0;\n  }\n\n  .container .open .arrowNav .arrowIcon {\n    transition: 0.5s;\n    rotate: 0deg;\n    margin-right: 0;\n  }\n\n  .container .content {\n    margin-left: 10vw;\n    width: 90vw;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .container {\n    flex-direction: column;\n  }\n\n  .container .navbar {\n    animation: none;\n    width: 80vw;\n    left: -80vw;\n  }\n\n  .container .navbar .navContent {\n    width: 100%;\n  }\n\n  .container .open {\n    left: 0;\n  }\n\n  .container .content {\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .container .content .headerPos .mobileHeader {\n    display: flex;\n  }\n\n  .container .content .headerPos {\n    width: 100%;\n  }\n\n  .container .content .headerPos .webHeader {\n    display: none;\n  }\n}\n\n@media screen and (min-height: 700px) {\n  .container .navbar .itemContainer {\n    margin-top: 5px;\n    height: 50px;\n  }\n\n  .container .navbar .navHeader .avatar .profilepic {\n    width: 60px;\n    height: 60px;\n  }\n\n  .container .navbar .navHeader .avatar .username {\n    font-size: 18px;\n  }\n}\n\n@media screen and (min-height: 700px) {\n  .container .navbar .itemContainer {\n    margin-top: 5px;\n    height: 40px;\n  }\n\n  .container .navbar .navHeader .avatar .profilepic {\n    width: 60px;\n    height: 60px;\n  }\n\n  .container .navbar .navHeader .avatar .username {\n    font-size: 18px;\n  }\n}\n\n@media screen and (max-height: 600px) {\n  .container .navbar .abaco_logo {\n    display: none;\n  }\n\n  .container .navbar .itemContainer {\n    margin-top: 10px;\n    height: 25px;\n  }\n\n  .container .navbar .navHeader .avatar .profilepic {\n    width: 50px;\n    height: 50px;\n  }\n\n  .container .navbar .navHeader .avatar .username {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .container {\n    position: relative;\n    flex-direction: column;\n  }\n\n  .container .navbar .abaco_logo {\n    width: 20rem;\n  }\n\n  .container .navbar {\n    transition: 0.5s;\n    animation: none;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: -100vw;\n    border-radius: 0;\n    opacity: 0.94;\n  }\n\n  .container .navbar .navContent {\n    width: 100%;\n  }\n\n  .container .open {\n    transition: 0.5s;\n    left: 0;\n  }\n\n  .container .content {\n    width: 100%;\n    height: 100%;\n    margin-left: 0;\n  }\n\n  .container .content .headerPos .mobileHeader {\n    display: flex;\n  }\n\n  .container .content .headerPos {\n    width: 100%;\n  }\n\n  .container .content .headerPos .webHeader {\n    display: none;\n  }\n\n  .container .content .outletPos {\n    margin-top: 20%;\n  }\n}\n\n@media print {\n  .navbar {\n    display: none !important;\n  }\n  .navHeader {\n    display: none !important;\n  }\n  .username {\n    display: none !important;\n  }\n  .open {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NavBar_container__tDXCs`,
	"navbar": `NavBar_navbar__cYhDd`,
	"init2": `NavBar_init2__gySGV`,
	"navContent": `NavBar_navContent__ngN1n`,
	"arrowNav": `NavBar_arrowNav__IvjLB`,
	"arrowIcon": `NavBar_arrowIcon__0MjbZ`,
	"navHeader": `NavBar_navHeader__37uAX`,
	"open": `NavBar_open__ERV6K`,
	"openarrow": `NavBar_openarrow__E21js`,
	"abaco_logo": `NavBar_abaco_logo__mme8y`,
	"profile": `NavBar_profile__yy2lJ`,
	"avatar": `NavBar_avatar__esDwP`,
	"profilepic": `NavBar_profilepic__yut+L`,
	"username": `NavBar_username__GsYuF`,
	"selector": `NavBar_selector__lxqwS`,
	"listItem": `NavBar_listItem__2nzjs`,
	"itemContainer": `NavBar_itemContainer__Uy-Qf`,
	"itemButton": `NavBar_itemButton__UJzcn`,
	"selectedItem": `NavBar_selectedItem__nj7Id`,
	"content": `NavBar_content__qDAh7`,
	"openContent": `NavBar_openContent__uoudR`,
	"headerPos": `NavBar_headerPos__OmdjV`,
	"mobileHeader": `NavBar_mobileHeader__TlYny`,
	"outletPos": `NavBar_outletPos__NGszb`,
	"webHeader": `NavBar_webHeader__jARTM`
};
export default ___CSS_LOADER_EXPORT___;
